<template>
  <section id="payments" class="bg-gray">
    <div class="container">
      <div class="cart-row">
        <div class="row-label"><p v-html="getTranslatedName('choose_payment')"></p></div>
      </div>

      <div class="cart-row" :key="payment.internal_name" v-for="payment in payments" :class="{'active': payment.internal_name === selectedPayment.internal_name}">
        <div class='payments-select' v-if="isValid(payment)">
          <label class="form-item">
            <input type='radio' :value="payment.internal_name" name='payment' v-on:click="setPayment(payment.internal_name)" :checked="payment.internal_name === selectedPayment.internal_name ? 'checked' : ''">
            <span class="radiobtn"></span> <span v-html="getTranslatedName(payment.name)"></span>
          </label>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  import store from "./../../store/index"

  export default {
    name: "Payments",
    computed: {
      itemsTotal() {
        return store.getters.itemsTotal;
      },
      payments() {
        return store.getters.payments;
      },
      selectedPayment() {
          return store.getters.payment;
      }
    },
    // watch: {
    //   preselect: function() {
    //     this.$emit('select', item);
    //   }
    // },
    methods: {
      getTranslatedName(name) {
        if(typeof  window.translations['CART_' + name] !== 'undefined')
          return window.translations['CART_' + name];
        return name;
      },
      isValid(payment)
      {
        let shipment = store.getters.shipment;
        if(shipment.internal_name === 'dealer')
        {
          return payment.internal_name !== 'cash_on_delivery';
        }
        return true;
      },
      setPayment(internal_name) {
        store.dispatch('setPayment', internal_name);
        this.$emit('payment', internal_name);
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Cart/Payments.vue